import { render, staticRenderFns } from "./UmsSyncAzureUsers.vue?vue&type=template&id=6fa52a14&"
import script from "./UmsSyncAzureUsers.vue?vue&type=script&lang=js&"
export * from "./UmsSyncAzureUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports